
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/school-onboard",
      function () {
        return require("private-next-pages/school-onboard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/school-onboard"])
      });
    }
  